module.exports = __webpack_public_path__ + "img/level-2-active.6079a294.svg";